import { Button, Card, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { useHistory, useParams } from "react-router";
import { useAppContext } from "../../../context/AuthContext";
import LabelsContext from "../../../lang/LabelsContext";
import EnumReviewStatus from "../../../utils/enum/EnumReviewStatus";
import { isUserAssociateEditor } from "../../../utils/Utils";
import ArticleCard from "../article-card/ArticleCard";
import TabReview from "../article-details/tab-review/TabReview";
import ArticleReviwer from "../article-reviwer/ArticleReviwer";
import MakeDecisionButton, { MakeDecisionButtonType } from "../make-decision-button/MakeDecisionButton";
import DecideOnStatusService, { DecideOnStatusServiceType } from "./DecideOnStatusService";
import { useStyles } from "./DecideOnStatusStyle";

export default function DecideOnStatus() {
  const { article, confirmSendToAssistant }: DecideOnStatusServiceType = DecideOnStatusService();
  const classes = useStyles();
  const { authData } = useAppContext();
  const { Labels } = LabelsContext();

  const history = useHistory();

  const { id }: any = useParams();

  const rightButtons = () => (
    <Grid container spacing={1}>
      <Grid item>
        <Button variant="contained" size="small" onClick={() => history.push(`/reviewerSelection/${id}`)}>
          {Labels.ACTION}
        </Button>
      </Grid>
    </Grid>
  );

  const makeDecisionArray = [
    {
      label: Labels.ACCEPT,
      reviewStatus: EnumReviewStatus.ACCEPTED,
      styleButton: { backgroundColor: "#00FF00" },
    },
    {
      label: Labels.MINOR_REVISION,
      reviewStatus: EnumReviewStatus.MINOR_REVISION,
      styleButton: { backgroundColor: "#FFFF00" },
    },
    {
      label: Labels.MAJOR_REVISION,
      reviewStatus: EnumReviewStatus.MAJOR_REVISION,
      styleButton: { backgroundColor: "#FF7F00" },
    },
    {
      label: Labels.REJECT,
      reviewStatus: EnumReviewStatus.REJECTED,
      styleButton: { backgroundColor: "#FF0000" },
    },
    {
      label: Labels.DIRECT_REJECT,
      reviewStatus: EnumReviewStatus.DIRECT_REJECT,
      styleButton: { backgroundColor: "#FF0000" },
    },
    {
      label: Labels.REJECTED_R0,
      reviewStatus: EnumReviewStatus.REJECTED_R0,
      styleButton: { backgroundColor: "#FF0000" },
    },
    {
      label: Labels.DIRECT_REJECT_R0,
      reviewStatus: EnumReviewStatus.DIRECT_REJECT_R0,
      styleButton: { backgroundColor: "#FF0000" },
    },
    {
      label: Labels.LETTER_TO_THE_EDITOR,
      reviewStatus: EnumReviewStatus.REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR,
    },
  ] as MakeDecisionButtonType[];

  const makeDecisionAssociate = {
    label: Labels.TO_ASSOCIATE_EDITOR,
    reviewStatus: EnumReviewStatus.ASSOCIATE_EDITOR,
  };

  return (
    <div>
      <Typography variant="h5">{Labels.DECIDE_ON_STATUS}</Typography>
      <Paper className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} spacing={3}>
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Card className={classes.card}>
                  <Typography variant="h6" className={classes.marginBottom}>
                    {Labels.SELECT_STATUS}
                  </Typography>
                  <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                    {makeDecisionArray.map((button: MakeDecisionButtonType) => (
                      <Grid key={button.label} item xs={12} sm={3}>
                        <MakeDecisionButton article={article} buttonProps={button} />
                      </Grid>
                    ))}
                  </Grid>
                </Card>
              </Grid>
              {!isUserAssociateEditor(authData) && (
                <Grid item className={classes.paddingBottom2}>
                  <Grid item xs={6} sm={6}>
                    <Card className={classes.makeDecisionCard}>
                      <Typography variant="h6" className={classes.paddingBottom2}>
                        Forward paper to:
                      </Typography>
                      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                        <Grid item xs={12} sm={6}>
                          <MakeDecisionButton
                            article={article}
                            buttonProps={makeDecisionAssociate}
                            style={{ backgroundColor: "orange", color: "white" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            color={"default"}
                            className={classes.buttonAssistantEditor}
                            onClick={confirmSendToAssistant}
                          >
                            Assistant editor
                          </Button>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>
              )}
              <Grid item spacing={3}>
                <ArticleCard
                  data={article}
                  index={0}
                  rightComponent={rightButtons}
                  showAssociateEditorDecision={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <ArticleReviwer article={article} />
        <TabReview editorView={true} articleId={id} />
      </Paper>
    </div>
  );
}
